export default __webpack_public_path__ + "static/media/smoothArrowIcon.f2817631.svg";